const ComplaintSecondSection = ({ amount, penalty }) => {
  return (
    <div className="recon-sec-container box-back">
      <div>
        <p className="recon-sec-head">Amount Breakup</p>
      </div>

      <div className="normal-section">
        <p className="normal-font">
          <span className="heading-new">Total Complaints Amount:</span>
          <span className="price">
            {" "}
            ₹{" "}
            {amount
              ? Intl.NumberFormat("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(amount)
              : "0.00"}
          </span>
        </p>
      </div>
      <div className="normal-section">
        <p className="normal-font">
          <span className="heading-new">Total Fees :</span>

          <span className="price">
            {" "}
            + ₹{" "}
            {penalty
              ? Intl.NumberFormat("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(penalty)
              : "0.00"}
          </span>
        </p>
      </div>
      <div className="normal-section line-data">
        <p className="normal-font">
          <span className="">Net Amount :</span>
          <span className="price">
            {" "}
            ₹{" "}
            {Intl.NumberFormat("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(amount + penalty)}
          </span>
        </p>
      </div>
    </div>
  );
};

export default ComplaintSecondSection;
